import React from "react";
import { Modal, Table } from "antd";
import { MultiScreenListItem } from "../../../../../../service/exam";
import { ColumnProps } from "antd/es/table";
import { ModalProps } from "antd/es/modal";

interface MultipleModalProps extends ModalProps {
    data: MultiScreenListItem[];
}

export default function MultipleModal({ data, ...props }: MultipleModalProps) {
    const columns: ColumnProps<MultiScreenListItem>[] = [
        { title: "时间", dataIndex: "time" },
        { title: "说明", dataIndex: "leaveName" }
    ];

    return (
        <Modal title="多屏记录" footer={false} {...props}>
            <Table
                rowKey="time"
                columns={columns}
                dataSource={data}
                pagination={false}
                scroll={{ y: 400 }}
            />
        </Modal>
    );
}
